<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
<app-sub-header [pageTitle]="'CarInspectionRegulations' | translate"></app-sub-header>

<div class="padded-container" *ngIf="rulesResponse">
  <dx-accordion [collapsible]="true" [multiple]="true" (onContentReady)="onContentReady($event)">
    <dxi-item *ngFor="let rule of rulesResponse.rules" [title]="rule.tilte">
      <p>{{ rule.description }}</p>
    </dxi-item>
  </dx-accordion>
  <div>
    <dx-check-box
      [text]="'RulesAccepted' | translate"
      [(ngModel)]="accepted"
      (ngModelChange)="onCheckboxChange()"
      style="margin-bottom: 20px;">
    </dx-check-box>
  </div>
  <div>
    <dx-button
      [text]="'Continue' | translate"
      (onClick)="navigateToClient()"
      [disabled]="!accepted"
      class="full-width-button"
      type="default">
    </dx-button>
  </div>
  <dx-button type="danger" class="full-width-button"
    (click)="navigateToPickCar()">
    {{ 'Back' | translate }}
  </dx-button>
</div>
</div>